export default "__VITE_ASSET__638631d4__"